import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import TextField from "@material-ui/core/TextField";
import NumericalTextField from "../../material-components/Misc/NumericalTextField";
import withModal from "../withModal";

const QuickBandingModal = ({ isOpen, modalProps }) => {
    const dispatch = useDispatch();

    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);
    const [stepSize, setStepSize] = useState(0);
    const [preview, setPreview] = useState("");

    useEffect(() => {
        if ((min != 0 || max != 0) && min < max && stepSize > 0 && stepSize <= max - min) {
            let bands = "";
            let last = min;
            for (let i = min; i <= max; i += stepSize) {
                last = i;
                let newBand = i.toString() + " ";
                bands += newBand;
            }

            if (last != max) {
                bands += max.toString();
            }

            setPreview(bands.trim());
        } else {
            setPreview("");
        }
    }, [max, min, stepSize]);

    const { setTextBoundaries } = modalProps;

    const onConfirm = () => {
        setTextBoundaries(preview);
        hide();
    };

    const hide = () => {
        setMin(0);
        setMax(0);
        setStepSize(0);
        setPreview("");
        dispatch(hideModal("QUICK_BANDS"));
    };

    return (
        <MaterialModal
            id="quick-banding-modal"
            isOpen={isOpen}
            title="Quick Banding"
            primaryButtonText="Confirm"
            onPrimaryButtonRequest={onConfirm}
            isPrimaryButtonDisabled={!preview}
            showPrimaryButton
            onClose={hide}
        >
            <div>
                <p style={{ margin: "0px 0px 10px" }}>Enter a new banding minimum, maximum, and increment below.</p>
                <div className="row">
                    <div className="col-md-4">
                        <NumericalTextField
                            label="Minimum"
                            fullWidth
                            value={min}
                            onBlur={e => setMin(parseInt(e.target.value))}
                        />
                    </div>
                    <div className="col-md-4">
                        <NumericalTextField
                            label="Maximum"
                            fullWidth
                            value={max}
                            onBlur={e => setMax(parseInt(e.target.value))}
                        />
                    </div>
                    <div className="col-md-4">
                        <NumericalTextField
                            label="Step Size"
                            fullWidth
                            value={stepSize}
                            onBlur={e => {
                                let value = parseInt(e.target.value);
                                if (value < 0) {
                                    value = 0;
                                }
                                setStepSize(value);
                            }}
                        />
                    </div>
                </div>
                <p style={{ margin: "20px 0px 0px" }}>Banding Preview:</p>
                <div className="row">
                    <div className="col-md-12">
                        <TextField
                            InputLabelProps={{
                                shrink: true,
                            }}
                            disabled
                            multiline
                            value={preview || "No Preview to Show"}
                        />
                    </div>
                </div>
            </div>
        </MaterialModal>
    );
};

QuickBandingModal.propTypes = {
    // Passed In
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Redux
    hideModal: PropTypes.func,
};
export default withModal(QuickBandingModal, "QUICK_BANDS");
